<template>
  <el-dialog :visible.sync="visible" :title="$t('update')" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <template>每月得赞总数班级前
      </template>
      <template><el-input-number v-model="dataForm.num" :min="1" :max="100" label="描述文字"></el-input-number>
      </template>
        <br>
        <template>每月进步前       </template>
      <template>
          <el-input-number v-model="dataForm.topNum" :min="1" :max="100" label="描述文字" style="left: 55px"></el-input-number>
      </template>
        <br>
        <template>关联一级维度</template>
            <el-select v-model="dataForm.typeId" placeholder="" style="left: 48px">
                <el-option
                        v-for="type in typeList"
                        :key="type.id"
                        :label="type.examineTypeName"
                        :value="type.id">
                </el-option>
            </el-select>
    </el-form>
<!--    <template>-->
<!--      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>-->
<!--      <div style="margin: 15px 0;"></div>-->
<!--    <el-checkbox-group v-model="checkedMonths" @change="handleCheckedCitiesChange" style="margin-top: 50px">-->

<!--    <el-checkbox-group v-model="checkedMonths"  style="margin-top: 50px">-->
<!--      <el-checkbox v-for="month in months" :label="month" :key="month">{{month}}月</el-checkbox>-->
<!--    </el-checkbox-group>-->
<!--      <p style="color: red">提示：请上学期至少选四个月且下学期至少选四个月</p>-->
<!--    </template>-->
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
import Template from '../devtools/template'
const cityOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
export default {
  components: { Template },
  data () {
    return {
      visible: false,
      checkAll: false,
      dataForm: {
        ruleDecorationId: '',
        rule: '',
        num: '',
        topNum: '',
        months: [],
        typeId: ''
      },
      options: [{
        value: '0',
        label: '大于等于'
      }, {
        value: '1',
        label: '大于',
        disabled: true
      }, {
        value: '2',
        label: '小于等于'
      }, {
        value: '3',
        label: '小于'
      }, {
        value: '4',
        label: '等于'
      }],
      form: {
        ruleDecorationId: ''
      },
      typeList: [],
      dataList: [],
      result: [],
      checkedMonths: [],
      months: cityOptions
    }
  },
  computed: {
    dataRule () {
      return {
        paramsValue: [
          { required: true, message: '参数不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getTypeList()
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        // if (this.form.ruleDecorationId) {
        //   this.getInfo()
        //   this.dataForm.typeId = this.dataList.typeId
        // }
      })
    },
    async getTypeList () {
      await this.$http.get('/thumb/thumbExamineType/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.typeList = res.data
        this.dataForm.typeId = this.typeList[0].id
        this.getInfo()
      }).catch(() => {})
    },

    handleCheckAllChange (val) {
      this.checkedMonths = val ? cityOptions : []
      this.isIndeterminate = false
    },
    // 获取信息
    getInfo () {
      this.$http.get('/yqtsz/ruledecoration/' + this.form.ruleDecorationId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        // this.dataForm.topNum = res.data.topNum
        this.dataList = res.data
        this.checkedMonths = res.data.monthsList
        const index = this.typeList.findIndex((role) => role.id === res.data.relevancyTypeId)
        console.log('+++---')
        console.log(this.index)
        this.dataForm.typeId = this.typeList[index].id
      }).catch(() => {})
    },

    checkTime () {
      this.dataForm.months = this.checkedMonths
      console.log('this.dataForm.months' + this.dataForm.months)
      if (this.dataForm.months.length < 8) {
        this.$alert('请上学期至少选四个月且下学期至少选四个月', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${action}`
            })
          }
        })
      } else {
        this.dataFormSubmitHandle()
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.ruleDecorationId = this.form.ruleDecorationId
        this.dataForm.months = this.checkedMonths
        this.$http.post('/yqtsz/ruledecoration/updateRuleAndMonths/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
